var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('img',{style:(`width: ${_vm.w};height: ${_vm.w};`),attrs:{"src":_vm.url,"alt":""}}):_c('span',{staticClass:"platform-placeholder",style:(`width: ${_vm.w};height: ${_vm.w};`)},[_vm._v(_vm._s(_vm.firstChar))])
}
var staticRenderFns = []

export { render, staticRenderFns }